import { getSampleById } from '../config/drumSamples';

/**
 * 安全的Sample ID到檔案路徑轉換（帶回退機制）
 * 確保所有地方使用相同的邏輯
 */
export const getSafeAudioUrl = (sampleId: string): string => {
  const sample = getSampleById(sampleId);
  if (!sample) {
    console.warn(`⚠️ Sample not found: ${sampleId}, using fallback`);
    // 回退到經典kick音檔
    return '/samples/kick-classic.wav';
  }
  
  // 使用 encodeURI 來處理路徑中的特殊字符，但保留 URI 結構
  return sample.file;
}; 